module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', [_c('b-progress', {
    attrs: {
      "value": 20
    }
  }), _vm._v(" "), _c('b-progress', {
    attrs: {
      "type": "is-danger",
      "value": 40
    }
  }), _vm._v(" "), _c('b-progress', {
    attrs: {
      "type": "is-success",
      "value": 60
    }
  }), _vm._v(" "), _c('b-progress', {
    attrs: {
      "type": "is-info",
      "value": 80
    }
  }), _vm._v(" "), _c('b-progress', {
    attrs: {
      "type": "is-warning",
      "value": 100
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-261f4e60"}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./docs/pages/components/progress/examples/ExTypes.vue
// module id = 1149
// module chunks = 25 198